/* eslint-disable no-unused-vars,no-useless-escape */

/* 金额 */
export function isMoney(str) {
  const reg = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/;
  return reg.test(str);
}

/* 手机号码 */
export function isMobile(str) {
  const reg = /^(\+?0?86-?)?1[3456789]\d{9}$/;
  return reg.test(str);
}

/* 电话号码 */
export function isPhone(str) {
  const reg = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/;
  return reg.test(str);
}

/* 身份证号码 */
export function isIdCardNo(str) {
  if (!/^[0-9]*([xX]?)$/.test(str)) return false;
  const city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 ',
  };

  if (!str || (str.length !== 15 && str.length !== 18)) { // 长度
    return false;
  } else if (!city[str.substr(0, 2)]) { // 省份
    return false;
  } else if (str.length === 18) { // 校验位
    // eslint-disable-next-line no-param-reassign
    str = str.split('');
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 加权因子
    const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]; // 校验位
    let sum = 0;
    let ai = 0;
    let wi = 0;
    for (let i = 0; i < 17; i += 1) {
      ai = str[i];
      wi = factor[i];
      sum += ai * wi;
    }

    if (parity[sum % 11].toString() !== str[17]) {
      return false;
    }
  } else if (str.length === 18) {
    const date8 = str.substring(6, 14);
    if (!/^[0-9]{8}$/.test(date8)) {
      return false;
    }
    const year = date8.substring(0, 4);
    const month = date8.substring(4, 6);
    const day = date8.substring(6, 8);
    const iaMonthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (year < 1700 || year > 2500) return false;
    if (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) iaMonthDays[1] = 29;
    if (month < 1 || month > 12) return false;
    if (day < 1 || day > iaMonthDays[month - 1]) return false;
  } else {
    const date6 = str.substring(6, 12);
    if (!/^[0-9]{6}$/.test(date6)) {
      return false;
    }

    const year = date6.substring(0, 2);
    const month = date6.substring(2, 4);
    const day = date6.substring(4, 6);
    if (!/^\d{2}$/.test(year)) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1 || day > 31) return false;
  }

  return true;
}

/* 统一信用代码 */
export function isUscc(str) {
  // 18位校验及大写校验
  if (!str || (str.length !== 18) || (!/^[0-9A-Z]+$/.test(str))) {
    return false;
  }

  let Ancode;
  let Ancodevalue;
  let logiccheckcode;
  let total = 0;
  const weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]; // 加权因子
  const ch = '0123456789ABCDEFGHJKLMNPQRTUWXY'; // 不用I、O、S、V、Z
  const Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y';

  for (let i = 0; i < str.length - 1; i += 1) {
    Ancode = str.substring(i, i + 1);
    Ancodevalue = ch.indexOf(Ancode);
    total += Ancodevalue * weightedfactors[i]; // 权重与加权因子相乘之和
  }

  logiccheckcode = 31 - (total % 31);
  if (logiccheckcode === 31) {
    logiccheckcode = 0;
  }

  return Str.split(',')[logiccheckcode] === str.substring(17, 18);
}

/* 营业执照 */
export function isBusLicen(str) {
  if (!str || (str.length !== 15)) {
    return false;
  }

  let lastNum;
  let ti = 0;
  let si = 0;
  let cj = 0;
  let pj = 10;
  for (let i = 0; i < str.length; i += 1) {
    ti = parseInt(str[i], 10);
    si = pj + ti;
    cj = (si % 10 === 0 ? 10 : si % 10) * 2;
    pj = cj % 11;
    if (i === str.length - 1) {
      lastNum = si % 10;
    }
  }

  return lastNum === 1;
}

/* 组织机构代码 8位数字字母+'-'+校验位 */
export function isOrgCode(str) {
  if (!str || (str.length !== 10)) return false;

  const ws = [3, 7, 9, 10, 5, 8, 4, 2];
  const ch = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  const values = str.split('-');
  if (!/^([0-9A-Z]){8}$/.test(values[0])) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 8; i += 1) {
    sum += ch.indexOf(values[0].charAt(i)) * ws[i];
  }

  let C9 = 11 - (sum % 11);
  const YC9 = `${values[1]}`;
  if (C9 === 11) {
    C9 = '0';
  } else if (C9 === 10) {
    C9 = 'X';
  } else {
    C9 += '';
  }

  return YC9 !== C9;
}

/* EMAIL */
export function isEmail(str) {
  const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
  return reg.test(str);
}



// WEBPACK FOOTER //
// ./src/utils/validate.js